import { render } from "./section-reference.vue?vue&type=template&id=06dfa33a&scoped=true"
import script from "./section-reference.vue?vue&type=script&lang=js"
export * from "./section-reference.vue?vue&type=script&lang=js"

import "./section-reference.vue?vue&type=style&index=0&id=06dfa33a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06dfa33a"]])

export default __exports__